var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"card-custom card-border",attrs:{"no-body":""}},[_c('b-card-body',[_c('under-construction')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }